import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var AlertTriangle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AlertTriangle_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.003 5a.764.764 0 0 0-.761.832l.38 4.279a.379.379 0 0 0 .754 0l.388-4.278A.764.764 0 0 0 8.004 5ZM7.421 12.755a.925.925 0 0 0 .583.187c.22 0 .41-.059.572-.176.169-.125.253-.345.253-.66 0-.315-.084-.532-.253-.649a.946.946 0 0 0-.572-.176.964.964 0 0 0-.583.176c-.161.117-.242.334-.242.649 0 .308.08.524.242.649Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22 1.571a2.017 2.017 0 0 1 3.563 0l5.939 10.715c.792 1.428-.198 3.214-1.782 3.214H2.062C.48 15.5-.51 13.714.281 12.286L6.22 1.57Zm2.688.485 5.94 10.715c.455.822-.155 1.729-.908 1.729H2.062c-.753 0-1.363-.907-.907-1.73l5.94-10.714c.41-.741 1.402-.741 1.813 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AlertTriangle_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default AlertTriangle;